import React from 'react';
import { marked } from 'marked';
import i18next from 'i18next';
import { Repeat } from '../../StyledComponents/Repeat';
import { ProductPageMainSection } from '../../StyledComponents/ProductPage';
import Content from '../../StyledComponents/Content';
import { H2 } from '../../StyledComponents/Heading';
import { ButtonInline } from '../../StyledComponents/Button';
import LogoBox from '../../StyledComponents/LogoBox';
import { PackageOption } from '../../@types/codegen/types';

interface PackageOptionsProps {
  packageOptions?: PackageOption[] | null;
}

const PackageOptions = ({ packageOptions }: PackageOptionsProps) => {
  if (!packageOptions) {
    return null;
  }

  return (
    <>
      {packageOptions.map((packageOption, index) => (
        <ProductPageMainSection key={packageOption.title || index}>
          <Repeat>
            <H2 noMargin>{packageOption.title}</H2>
          </Repeat>
          {packageOption.description && (
            <Repeat>
              <Content dangerouslySetInnerHTML={{ __html: marked(packageOption.description) }} />
            </Repeat>
          )}
          {packageOption.link?.url && (
            <Repeat>
              <ButtonInline
                as="a"
                href={packageOption.link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {packageOption.link.title ? packageOption.link.title : i18next.t('item.readMoreInNewTab')}
              </ButtonInline>
            </Repeat>
          )}
          {packageOption.image && (
            <Repeat>
              <LogoBox logo={packageOption.image} alt={i18next.t('common.logotype') || ''} wide />
            </Repeat>
          )}
        </ProductPageMainSection>
      ))}
    </>
  );
};

export default PackageOptions;
